export const defaultConfig = {
  defaultLayoutMode: 'static',
  fixedBottomBar: false
};